import React from 'react';
import Draggable from 'react-draggable';
import { updateNonRectangularShape, selectShape, updateCurrentSlideThumbnail, changeInteractionState } from '../../../actions/CurrentSlideActions';
import { uiProperties, getTouchPosition } from '../../utils/TransformToolUtils';
import appParameters from '../../utils/AppParameters';
import modeType from '../../../constants/ModeConstants';
import previewCommands from '../../utils/PreviewCommands';
import selectionManager from '../../utils/SelectionManager';
import platformDetection from '../../utils/PlatformDetection';
import animationManager from '../../utils/AnimationManager';
import saveManager from '../../utils/SaveManager';
import audioEditorUtils from '../../audioEditor/utils/AudioEditorUtils';
import { refreshShapePosition } from '../../../actions/MenuActions';

export const InteractiveNonRectangularShape = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        children: React.PropTypes.object.isRequired,
        shapeModel: React.PropTypes.object.isRequired
    },
    getInitialState() {
        return {
            interaction: 'none',
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            cx: 0,
            cy: 0,
            isMultipleSelection: false
        };
    },
    componentDidMount() {
        if (platformDetection.isFirefox() == false)
            document.addEventListener('mouseout', this.onFocusOut);
    },
    componentWillUnmount() {
        if (platformDetection.isFirefox() == false)
            document.removeEventListener('mouseout', this.onFocusOut);
    },
    onFocusOut(evt) {
        var position = getTouchPosition(evt);
        if (position.x < 2 || position.y < 2 || position.x > (window.innerWidth - 2) || position.y > (window.innerHeight -2)) {
            if (this.state.interaction == 'Start' || this.state.interaction == 'End' || this.state.interaction == 'Control')
                this.onResizeStopped();
            else if (this.state.interaction == 'move')
                this.onMoveShapeStopped();
        }
    },
    getCorrectId(id) {
        var index = id.indexOf('_');

        if (index != -1)
            return id.substring(0, index);
        else
            return id;
    },
    setInitialPosition (interaction) {
        const {shapeModel} = this.props;

        this.setState({
            x1: parseFloat(shapeModel.x1),
            y1: parseFloat(shapeModel.y1),
            x2: parseFloat(shapeModel.x2),
            y2: parseFloat(shapeModel.y2),
            cx: parseFloat(shapeModel.cx),
            cy: parseFloat(shapeModel.cy),
            interaction: interaction,
            isMultipleSelection: selectionManager.multipleSelection()
        });
    },
    updateThumbnail () {
        const {dispatch} = this.props;
        dispatch(updateCurrentSlideThumbnail(true));
    },
    onMoveShapeStart (e) {
        e.preventDefault();
        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true  || shapeModel.isGrouped == true)
            return;

        this.setInitialPosition('move');
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, true));

        selectionManager.checkSelection(shapeModel.uuid);
        selectionManager.updateInitialPositions(shapeModel.uuid);
    },
    onMoveShape(e, coreEvent) {
        if (this.state.interaction != 'move')
            return;

        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true  || shapeModel.isGrouped == true)
            return;

        const xOffset = coreEvent.lastX / this.scaleFactor();
        const yOffset = coreEvent.lastY / this.scaleFactor();

        dispatch(updateNonRectangularShape(
            shapeModel.uuid,
            this.state.x1 + xOffset,
            this.state.y1 + yOffset,
            this.state.x2 + xOffset,
            this.state.y2 + yOffset,
            this.state.cx + xOffset,
            this.state.cy + yOffset
        ));

        if (this.state.isMultipleSelection)
            selectionManager.moveShapes(xOffset, yOffset, shapeModel.uuid);

        saveManager.isContentChanged(true);
    },
    onMoveShapeStopped (e, coreEvent) {
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, false));

        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true  || shapeModel.isGrouped == true) {
            dispatch(selectShape(shapeModel.uuid));

            return;
        }

        if (this.state.interaction != 'move')
            return;

        if (coreEvent) {
            const offsetX = coreEvent.lastX / this.scaleFactor();
            const offsetY = coreEvent.lastY / this.scaleFactor();

            dispatch(updateNonRectangularShape(
                shapeModel.uuid,
                this.state.x1 + offsetX,
                this.state.y1 + offsetY,
                this.state.x2 + offsetX,
                this.state.y2 + offsetY,
                this.state.cx + offsetX,
                this.state.cy + offsetY
            ));

            selectionManager.moveShapes(offsetX, offsetY, shapeModel.uuid);
        }

        dispatch(selectShape(shapeModel.uuid));

        this.setState({
            interaction:'none',
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            cx: 0,
            cy: 0,
            isMultipleSelection: false
        });

        audioEditorUtils.addActionToHistory();
        this.updateThumbnail();
        saveManager.isContentChanged(true);

        dispatch(refreshShapePosition(this.props.shapeModel.uuid));
    },
    onResizeStart (e, coreEvent) {
        const {shapeModel} = this.props;
        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, true));

        if (shapeModel.isLocked == true)
            return;

        this.setInitialPosition(this.getCorrectId(coreEvent.node.id));
    },
    getNewPosition (coreEvent) {
        const {shapeModel} = this.props;

        let id =  this.getCorrectId(coreEvent.node.id);
        let x1 = shapeModel.x1;
        let x2 = shapeModel.x2;
        let y1 = shapeModel.y1;
        let y2 = shapeModel.y2;
        let cx = shapeModel.cx;
        let cy = shapeModel.cy;

        var offsetX = coreEvent.lastX / this.scaleFactor();
        var offsetY = coreEvent.lastY / this.scaleFactor();

        if (id == 'Start') {
            x1 = this.state.x1 + offsetX;
            y1 = this.state.y1 + offsetY;
        } else if (id == 'End') {
            x2 = this.state.x2 + offsetX;
            y2 = this.state.y2 + offsetY;
        } else if (id == 'Control') {
            cx = this.state.cx + offsetX;
            cy = this.state.cy + offsetY;
        }

        return {
            x1,
            y1,
            x2,
            y2,
            cx,
            cy
        };
    },
    onResize (e, coreEvent) {
        if (this.state.interaction == 'none')
            return;

        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true)
            return;

        let newPosition = this.getNewPosition(coreEvent);

        dispatch(updateNonRectangularShape(
            shapeModel.uuid,
            newPosition.x1,
            newPosition.y1,
            newPosition.x2,
            newPosition.y2,
            newPosition.cx,
            newPosition.cy
        ));

        saveManager.isContentChanged(true);
    },
    onResizeStopped (e, coreEvent) {
        if (this.state.interaction == 'none')
            return;

        this.props.dispatch(changeInteractionState(this.props.shapeModel.uuid, false));
        const {shapeModel, dispatch} = this.props;

        if (shapeModel.isLocked == true)
            return;

        if (coreEvent) {
            let newPosition = this.getNewPosition(coreEvent);

            dispatch(updateNonRectangularShape(
                shapeModel.uuid,
                newPosition.x1,
                newPosition.y1,
                newPosition.x2,
                newPosition.y2,
                newPosition.cx,
                newPosition.cy
            ));
        }

        this.setState({
            interaction:'none',
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            cx: 0,
            cy: 0
        });

        audioEditorUtils.addActionToHistory();
        this.updateThumbnail();
        saveManager.isContentChanged(true);

        dispatch(refreshShapePosition(this.props.shapeModel.uuid));
    },
    scaleFactor() {
        return this.props.scaleProperties.scale;
    },
    render () {
        const {x1, y1, x2, y2, cx, cy, isLocked} = this.props.shapeModel;
        var isSelected = this.props.shapeModel.isSelected;

        if (appParameters.getMode() == modeType.PLAYER)
            isSelected = false;

        let cornerFill;
        let cornerStroke;

        if (this.state.interaction == 'Start' || this.state.interaction == 'End' || this.state.interaction == 'Control') {
            cornerFill = uiProperties.CORNER_FILL_ACTIVE;
            cornerStroke = uiProperties.CORNER_STROKE_ACTIVE;
        } else {
            cornerFill = uiProperties.CORNER_FILL_INACTIVE;
            cornerStroke = uiProperties.CORNER_STROKE_INACTIVE;
        }

        let x = (x1 && x2) ? Math.min(x1, x2) : 0;
        let y = (y1 && y2) ? Math.min(y1, y2) : 0;

        let width = Math.abs(x1 - x2);
        let height = Math.abs(y1 - y2);

        var radiusOffset = 0;

        if (platformDetection.isIOS())
            radiusOffset = 2;

        const scale = this.props.scaleProperties.scale;
        const radius = (uiProperties.RADIUS + radiusOffset) / scale;
        const lockScale = 2;

        var isLockedVisible = false;

        if (isSelected && isLocked && previewCommands.isEditorMode() == true)
            isLockedVisible = true;

        var interactivity;

        // in animation mode, only the shapes from the current animations should be clickable
        if (animationManager.clone && !this.props.shapeModel.isGrouped) {
            let clones = animationManager.getAllAnimationTargets();
            let isInTargets = false;

            for (let idx = 0; idx < clones.length; idx ++) {
                if (clones[idx].uuid === this.props.shapeModel.uuid)
                    isInTargets = true;
            }

            if (!isInTargets)
                interactivity = 'none';
        }

        return (
            <g pointerEvents={interactivity} transform={`translate(${x} ${y})`}>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMoveShapeStart} onDrag={this.onMoveShape} onStop={this.onMoveShapeStopped}>
                    {React.cloneElement(React.Children.only(this.props.children), {
                        x: 0,
                        y: 0
                    })}
                </Draggable>
                {
                    isSelected ?
                    <g transform={''}>
                    {
                        this.state.interaction == 'none' || this.state.interaction == 'Start' ?
                        <Draggable axis="none" position={{x:0, y:0}} onStart={this.onResizeStart} onDrag={this.onResize} onStop={this.onResizeStopped}>
                            <circle id={"Start_" + Math.random()} cx={x1 - x} cy={y1 - y} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                        </Draggable>
                        : null
                    }
                    {
                        this.state.interaction == 'none' || this.state.interaction == 'End' ?
                        <Draggable axis="none" position={{x:0, y:0}} onStart={this.onResizeStart} onDrag={this.onResize} onStop={this.onResizeStopped}>
                             <circle id={"End_" + Math.random()} cx={x2 - x} cy={y2 - y} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                        </Draggable>
                         : null
                    }
                    </g>
                    : null
                }
                {
                    (cx && cy) && isSelected && (this.state.interaction == 'none' || this.state.interaction == 'Control') ?
                    <Draggable axis="none" position={{x:0, y:0}} onStart={this.onResizeStart} onDrag={this.onResize} onStop={this.onResizeStopped}>
                        <circle id={"Control_" + Math.random()} cx={cx - x} cy={cy - y} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                    </Draggable>
                    : null
                }
                {
                    isLockedVisible?
                        <g transform={`translate(${width/2 - 10/lockScale} ${height/2 - 12.5/lockScale}) scale(${1/lockScale} ${1/lockScale})`}>
                            <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/lock.png'} x="0" y="0" width="20px" height="25px" preserveAspectRatio="none"/>
                        </g>
                        : null
                }
            </g>
    );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/interactive/InteractiveNonRectangularShape.js
 **/